import React, { useState, useEffect } from "react";

import { Typeahead } from "react-bootstrap-typeahead";
import { useLocation, useNavigate } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import moment from "moment-timezone";
import Select from "react-select";
import jwt_decode from "jwt-decode";
import PubSub from "pubsub-js";
import solisPowerApi from "../../api/solisPowerApi";
import {
  Button,
  Breadcrumb,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
  Stack,
  FormSelect,
  FormControl,
} from "react-bootstrap";

import {
  formatDate,
  getUserDetails,
  formatDateTime,
  getFormattedTimestamp,
  getFormattedTimestampOfDate,
} from "../../utils/helper";
import { validationMessages } from "../../utils/messages";
import { ROUTES } from "../../constants/webRouting";

// Define initial errors i.e. required field and their message
const initialErrors = {
  owner_id: { message: validationMessages.ownerId.required },
  orderid: { message: validationMessages.orderId.required },
  handover_date: { message: validationMessages.handoverDate.required },
  // orderid: { message: validationMessages.orderId.required },
};

const userInfo = getUserDetails();
const initialValues = {
  owner_id: userInfo?.id,
  owner_name: userInfo?.username,
};

const HandoverEdit = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  // handover state
  const [handover, setHandover] = useState(
    location.state ? location.state : initialValues
  );

  const [orders, setOrders] = useState([]);

  //errors state
  const [errors, setErrors] = useState(!props.visitData ? initialErrors : {});
  console.log("Handover Edit Call", handover);
  // Validation state
  const [validated, setValidated] = useState(false);

  // assign users state
  const [assignUsers, setAssignUsers] = useState([]);
  const [offers, setOffers] = useState([]);
  async function init() {
    const resultedUsers = await solisPowerApi.fetchUsers();
    resultedUsers && Array.isArray(resultedUsers)
      ? setAssignUsers(
        resultedUsers.map((user) => ({
          value: user.id,
          label: user.username,
        }))
      )
      : setAssignUsers([]);
    const fetchOffers = await solisPowerApi.fetchOffersForHandover();
    Array.isArray(fetchOffers) &&
      setOffers(
        fetchOffers?.map((fetchOffer) => ({
          offer_id: fetchOffer?.id,
          offer_name_label: `${fetchOffer?.offer_name_label || ""}`,
          offerData: fetchOffer,
        }))
      );

    const fetchedOrders = await solisPowerApi.fetchOrdersForOrderAMC();
    console.log("fetchedOrders", fetchedOrders);
    Array.isArray(fetchedOrders) &&
      setOrders(
        fetchedOrders?.map((fetchedOrder) => ({
          orderid: fetchedOrder?.id,
          offer_name_label: `${fetchedOrder?.offer_name_label || ""}`,
          offerData: fetchedOrder,
        }))
      );
  }
  useEffect(() => {
    init();
  }, []);

  // const [show, setShow] = useState(false);
  // const [selectedUser, setSelectedUser] = useState('');
  const [optionUsers, setOptionUsers] = useState([]);
  // const [ownerList, setOwnerList] = useState([]);
  // const [defaultOwner, setDefaultOwner] = useState([]);
  // const [defaultTargetDate, setDefaultTargetDate] = useState(new Date());

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == "owner_id") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.ownerId.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    if (name == "orderid") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.orderId.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    if (name == "owner_id") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.ownerId.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }

    }

    if (name == "handover_date") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.handoverDate.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    setHandover((prev) => ({ ...prev, [name]: value }));
  };

  const checkRequiredFields = () => {
    let isError = false;

    if (handover?.owner_id) {
      if (handover?.owner_id == "") {
        setErrors((prev) => ({
          ...prev,
          owner_id: { message: validationMessages.ownerId.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["owner_id"];
          return { ...prev };
        });
      }
    }
    if (handover?.orderid) {
      if (handover?.orderid == "") {
        setErrors((prev) => ({
          ...prev,
          orderid: { message: validationMessages.orderId.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["orderid"];
          return { ...prev };
        });
      }
      if (handover?.handover_date) {

        if (handover?.handover_date == "") {
          setErrors((prev) => ({ ...prev, 'handover_date': { message: validationMessages.handoverDate.required } }));
          isError = true;
        } else {
          setErrors((prev) => {
            delete prev['handover_date'];
            return { ...prev };
          });
        }

      }
    }
    // if (handover?.orderid) {
    //   if (handover?.orderid == "") {
    //     setErrors((prev) => ({
    //       ...prev,
    //       orderid: { message: validationMessages.orderId.required },
    //     }));
    //     isError = true;
    //   } else {
    //     setErrors((prev) => {
    //       delete prev["orderid"];
    //       return { ...prev };
    //     });
    //   }
    // }
    // handle errors for required fields
    if (!handover?.orderid) {
      setErrors((prev) => ({ ...prev, 'orderid': { message: validationMessages.orderId.required } }));
      isError = true;
    }
    if (!handover?.owner_id) {
      setErrors((prev) => ({ ...prev, 'owner_id': { message: validationMessages.ownerId.required } }));
      isError = true;
    }
    return isError;

    // if (
    //   handover.title &&
    //   handover.title.trim() !== "" &&
    //   handover.status &&
    //   handover.status.trim() !== "" &&
    //   handover.priority &&
    //   handover.priority.trim() !== "" &&
    // ) {
    //   return false;
    // }

    // return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    delete handover.owner_name;
    delete handover.name;
    delete handover.offer_name_label;
    delete handover.warranty_start_date;
    // Fix By Ali : Handle handover date
    handover.handover_date = formatDate(handover.handover_date);

    if (handover?.id) {
      const result = await solisPowerApi.saveHandOverRecord(handover);
      if (result?.success) {
        // submitHandoverData();
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record Save successfully",
        });
        navigate(`${ROUTES.HANDOVER.LIST}/${handover?.id}`, {
          state: handover,
        });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: result?.errors,
        });
      }
    } else {
      const result = await solisPowerApi.createHandoverRecord(handover);
      console.log("Create handover API Result", result);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record Save successfully",
        });
        navigate(`${ROUTES.HANDOVER.LIST}/${result.id}`, {
          state: result.data,
        });
        // submitHandoverData();
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: result?.errors,
        });
      }
    }
  };

  const submitHandoverData = () => {
    console.log("Props handovers", props);
    // props.submitHandover();
  };
  var warranty_start_date;
  const onOfferSelect = (e) => {
    const value = e.value;
    const label = e.label;
    const orders = e?.offerData

    // console.log("label, value", label, value);
    // const leadData = leads.filter((lead) => lead.id == e.value)?.at(0)?.leadData;
    // console.log("offers ID", offers);
    //const offerData = orders.filter((order) => order.id == e.value)?.at(0)?.orders;
    console.log("warrData", e);

    const handoverRecord = {};
    handoverRecord.email = orders?.email || "";
    handoverRecord.pincode = orders?.pincode || "";
    handoverRecord.city = orders?.city || "";
    handoverRecord.warranty_upto = orders?.warranty_upto || "";
    handoverRecord.cabin_metal = orders?.cabin_metal || "";
    handoverRecord.is_geared = orders?.is_geared || "";
    handoverRecord.warranty_start_date = orders?.warranty_start_date || "";

    handoverRecord.offer_id = orders?.offer_id;
    handoverRecord.lead_id = orders?.lead_id;

    //console.log("warranty_start_date",warranty_start_date);
    setHandover((prev) => ({ ...prev, ...handoverRecord }));
    handleChange({ target: { name: "orderid", value: e.value } });
    handleChange({ target: { name: "offer_name_label", value: e.label } });
  };

  const handleCancel = () => {
    if (handover.id) {
      navigate(`${ROUTES.HANDOVER.LIST}/${handover.id}`, { state: handover });
    } else {
      navigate(ROUTES.HANDOVER.LIST);
    }
  };

  return (
    <Container className="pb-5">
      <Row>
        <Col md={12}>
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HANDOVER.LIST)}>
              Handover
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col md={12}>
          <Form
            className=""
            onSubmit={() => handleSubmit}
            noValidate
            validated={validated}
          >
            <Card className="shadow view-form">
              <CardHeader className="bg-custom text-white">
                <Row className="w-100">
                  <Col lg={6} className="">
                    <div className="d-flex align-items-center h-100 gap-3">
                      {handover?.id ? (
                        <h5 className="m-0">Edit Handover {""}</h5>
                      ) : (
                        <h5 className="m-0">Create Handover</h5>
                      )}
                    </div>
                  </Col>
                  <Col lg={6} className="p-0">
                    <Stack direction="horizontal" className="float-end" gap={2}>
                      <Button
                        size="sm"
                        className="btn-save"
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                      <Button
                        size="sm"
                        className="btn-delete"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </Stack>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="">
                <Row>
                  <Col lg={12}>
                    <Row>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTargetdate"
                          >
                            Handover date
                          </Form.Label>
                          <Form.Control
                            required
                            type="date"
                            name="handover_date"
                            placeholder="Enter Handover Date"
                            value={formatDate(handover.handover_date || "")}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.targetdate?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      {/* <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicTargetdate"
                      >
                        warranty date
                      </Form.Label>
                      <Form.Control
                        disabled
                        // type="date"
                        placeholder="Warranty Date"
                        // value={handover?.warranty_start_date}
                        value={formatDate(handover?.warranty_start_date || "")}
                        
                        // defaultValue={moment(handover?.warranty_start_date).format(
                        //   "YYYY-MM-DD"
                        // )}
                      />
                    </Form.Group>
                  </Col> */}
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicOwner"
                          >
                            Order (Completed)
                          </Form.Label>
                          <Select
                            placeholder="Select your Order"
                            required
                            name="orderid"
                            className={`${handover?.orderid
                                ? "custom-select-valid"
                                : "custom-select-invalid"
                              }`}
                            onChange={(e) => {
                              onOfferSelect(e);
                            }}
                            options={orders?.map((offer) => ({
                              value: offer?.orderid,
                              label: offer?.offer_name_label,
                              offerData: offer?.offerData
                            }))}
                            value={
                              handover?.orderid
                                ? {
                                  value: handover?.orderid || "",
                                  label: handover?.offer_name_label || "",
                                }
                                : ""
                            }
                          />
                          {errors?.orderid?.message && !handover.orderid && (
                            <div className="feedback-invalid">
                              {errors?.orderid?.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      {/* Order Id */}

                      {/* <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicOwner"
                          >
                            Order
                          </Form.Label>
                          <Select
                            placeholder="Select your offer"
                            required
                            name="orderid"
                            className={`${
                              handover?.orderid
                                ? "custom-select-valid"
                                : "custom-select-invalid"
                            }`}
                            // onChange={(e) => {
                            //   onOrderAmcSelect(e);
                            // }}
                            onChange={(e) => {
                              handleChange({
                                target: { name: "orderid", value: e.value },
                              });
                              handleChange({
                                target: { name: "offer_name_label", value: e.label },
                              });
                            }}
                            options={orders?.map((order) => ({
                              value: order?.orderid,
                              label: order?.offer_name_label,
                            }))}
                            value={
                              handover?.orderid
                                ? {
                                    value: handover?.orderid || "",
                                    label: handover?.offer_name_label || "",
                                  }
                                : ""
                            }
                          />
                          {errors?.orderid?.message && !handover.orderid && (
                            <div className="feedback-invalid">
                              {errors?.orderid?.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col> */}

                      {/* End Here */}
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicOwner"
                          >
                            Assign Staff
                          </Form.Label>
                          <Select
                            required
                            name="owner_id"
                            className={`${handover?.owner_id
                                ? "custom-select-valid"
                                : "custom-select-invalid"
                              }`}
                            onChange={(e) => {
                              handleChange({
                                target: { name: "owner_id", value: e.value },
                              });
                              handleChange({
                                target: { name: "owner_name", value: e.label },
                              });
                            }}
                            options={assignUsers}
                            value={handover?.owner_id ? { value: handover?.owner_id || "", label: handover?.owner_name || "", } : ""}
                          />
                          {errors?.owner_id?.message && !handover.owner_id && (
                            <div className="feedback-invalid">
                              {errors?.owner_id?.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Email
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="email"
                            placeholder="Enter Email"
                            value={handover?.email || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.email?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Company Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="company_name"
                            placeholder="Enter Company Name"
                            value={handover?.company_name || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.company_name?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Ho Year
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="ho_year"
                            placeholder="Enter Hour Year"
                            value={handover?.ho_year || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.ho_year?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      {/* </Row>
                <Row>  */}
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            City
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="city"
                            placeholder="Enter City"
                            value={handover?.city || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.city?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Pincode
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="pincode"
                            placeholder="Enter Pincode"
                            value={handover?.pincode || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.pincode?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      {/* <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicTitle"
                      >
                        Handover
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="handover"
                        placeholder="Enter Handover"
                        value={handover?.handover || ""}
                        onChange={handleChange}
                      />
                      <FormControl.Feedback type="invalid">
                        {errors?.handover?.message}
                      </FormControl.Feedback>
                    </Form.Group>
                  </Col> */}
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Site Type
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="site_type"
                            placeholder="Enter Site Type"
                            value={handover?.site_type || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.site_type?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Contact Person Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="contact_person_name"
                            placeholder="Enter Contact Person Name"
                            value={handover?.contact_person_name || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.contact_person_name?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Is Geared
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="is_geared"
                            placeholder="Enter Is Geared"
                            value={handover?.is_geared || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.is_geared?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            File Number
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="file_no"
                            placeholder="Enter File Number"
                            value={handover?.file_no || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.file_no?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Site Address
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="site_address"
                            placeholder="Enter Site Address"
                            value={handover?.site_address || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.site_address?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      {/* <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicTitle"
                      >
                        Product capacity
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="site_address"
                        placeholder="Enter Product Capacity"
                        value={handover?.product_capacity || ""}
                        onChange={handleChange}
                      />
                      <FormControl.Feedback type="invalid">
                        {errors?.product_capacity?.message}
                      </FormControl.Feedback>
                    </Form.Group>
                  </Col> */}
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Stops
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="total_stops"
                            placeholder="Enter Stops"
                            value={handover?.total_stops || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.total_stops?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Auto Manual
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="auto_manual"
                            placeholder="Enter Auto Manual"
                            value={handover?.auto_manual || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.auto_manual?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            cabin metal
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="cabin_metal"
                            placeholder="Enter Cabin Metal"
                            value={handover?.cabin_metal || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.cabin_metal?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Elevator Type
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="elevator_type"
                            placeholder="Enter Elevator Type"
                            value={handover?.elevator_type || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.elevator_type?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Warranty Upto
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="warranty_upto"
                            placeholder="Enter Warranty Upto"
                            value={handover?.warranty_upto || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.warranty_upto?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Customer Name Second
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="customer_name_second"
                            placeholder="Enter Customer Name Second"
                            value={handover?.customer_name_second || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.customer_name_second?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicTitle"
                          >
                            Lost By
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="lost_by"
                            placeholder="Enter Lost By"
                            value={handover?.lost_by || ""}
                            onChange={handleChange}
                          />
                          <FormControl.Feedback type="invalid">
                            {errors?.lost_by?.message}
                          </FormControl.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default HandoverEdit;
